import React, { useEffect } from "react";
import * as Tooltip from "@radix-ui/react-tooltip";
import {InfoCircledIcon} from "@radix-ui/react-icons";
import "../css/AppDialog.css";


export function InfoIcon({text}) 
    {
      return (
        <Tooltip.Provider>
          <Tooltip.Root>
            <Tooltip.Trigger asChild>
              <InfoCircledIcon className="Info-icon"/>
            </Tooltip.Trigger>
            <Tooltip.Content className="TooltipContent" sideOffset={5}>
              {text}
            </Tooltip.Content>
          </Tooltip.Root>
        </Tooltip.Provider>
      );
    }

export interface AppDialogProps {
  isOpen: boolean;
  OnClose: () => void;
  title?:string;
  children?: React.ReactNode;
}

const AppDialog: React.FC<AppDialogProps> = ({isOpen, OnClose, title, children}) => {
    
    useEffect(() => {
      if (isOpen) {
        document.body.style.overflow = "hidden";
      } else {
        document.body.style.overflow = "auto";
      }

      return () => {
        document.body.style.overflow = "auto";
      };
    }, [isOpen]);

    if (!isOpen) return null;

    return (
    <div className="dialog-overlay" onClick={OnClose}>
      <div className="dialog-content-left-slide" onClick={(e) => e.stopPropagation()}>
        <div className="dialog-header">
          <h2>{title}</h2>
          <button className="dialog-close" onClick={OnClose}>
            ✕
          </button>
        </div>
        <div className="dialog-body">
          {React.Children.map(children, (child) => {
            if (React.isValidElement(child)) {
              return React.cloneElement(child as React.ReactElement<{ onDialogClose?: () => void }>, {
                onDialogClose: OnClose,
              });
            }
            return child;
          })}  
        </div>
      </div>
    </div>
  );
};

export default AppDialog;